document.addEventListener('click', function (evt) {
  var btn = evt.target.closest('.adda-quick-add-icon');
  if (!btn) return;

  evt.preventDefault();
  evt.stopPropagation();

  var variantId = btn.dataset.variantId;
  if (!variantId || btn.classList.contains('loading')) return;

  btn.classList.add('loading');
  var spinner = btn.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden');

  var svgIcon = btn.querySelector('svg.icon:not(.icon-spinner)');
  if (svgIcon) svgIcon.classList.add('hidden');

  var cartDrawer = document.querySelector('cart-drawer');
  var body = {
    items: [{ id: parseInt(variantId, 10), quantity: 1 }],
  };

  if (cartDrawer) {
    body.sections = cartDrawer.getSectionsToRender().map(function (s) {
      return s.id;
    });
    body.sections_url = window.location.pathname;
  } else {
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;
  }

  fetch(routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(body),
  })
    .then(function (r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then(function (parsedState) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else if (document.querySelector('cart-notification')) {
        document.querySelector('cart-notification').renderContents(parsedState);
      } else {
        window.location = routes.cart_url;
      }

      btn.classList.add('in-cart');
      btn.innerHTML =
        '<svg class="icon icon-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none"><path stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M3.75 9l3.75 3.75 6.75-7.5"/></svg>' +
        (spinner ? spinner.outerHTML : '');
    })
    .catch(function (e) {
      console.error('[adda-quick-add-icon]', e);
    })
    .finally(function () {
      btn.classList.remove('loading');
      var updatedSpinner = btn.querySelector('.loading__spinner');
      if (updatedSpinner) updatedSpinner.classList.add('hidden');
      var updatedSvg = btn.querySelector('svg.icon:not(.icon-spinner)');
      if (updatedSvg) updatedSvg.classList.remove('hidden');
    });
});
